import Inspector from './inspector';
import EditRow from './row/edit';

const { RichText, InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const {
    containerized,
    thead,
    tfoot,
    lines,
    columns,
    labels,
    variant,
    margin,
  } = attributes;

  // Monta o Cabeçalho
  const tHeadCols = [];
  for (let i = 0; i < columns; i++) {
    const text = labels[0]?.columns[i];

    tHeadCols.push(
      <th key={`th-${i}`}>
        <RichText
          tagName="p"
          selector="p"
          className={`Typography text center color-blue-dark margin-none`}
          value={text}
          placeholder="Header label"
          keepPlaceholderOnFocus
          onChange={(val) => changeLabels('head', val, i)}
        />
      </th>
    );
  }

  // Monta o corpo da tabela
  const rows = [];
  for (let i = 0; i < lines; i++) {
    rows.push(
      <EditRow
        key={`line-${i}`}
        line={i}
        columns={columns}
        attributes={attributes}
        setAttributes={setAttributes}
      />
    );
  }

  // Monta o Rodapé
  const tFootCols = [];
  for (let i = 0; i < columns; i++) {
    const text = labels[1]?.columns[i];

    tFootCols.push(
      <td key={`foot-${i}`}>
        <RichText
          tagName="p"
          selector="p"
          className={`Typography subtitle center color-black margin-none`}
          value={text}
          placeholder="Footer label"
          keepPlaceholderOnFocus
          onChange={(val) => changeLabels('foot', val, i)}
        />
      </td>
    );
  }

  // Altera os Textos do Head e do Foot
  const changeLabels = (key, text, col) => {
    const newLabels = labels.map((item) => {
      if (key === 'head') {
        labels[0].columns[col] = text;
      } else if (key === 'foot') {
        labels[1].columns[col] = text;
      }

      return item;
    });

    setAttributes({ labels: newLabels });
  };

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div
        className={`customTable
          ${margin}
          ${variant}
          ${containerized ? 'Container' : ''}
        `}
      >
        <table
          cellspacing="0"
          cellpadding="0"
          className="customTable-wrap margin-base"
        >
          {thead && (
            <thead>
              <tr>{tHeadCols}</tr>
            </thead>
          )}

          <tbody>{rows}</tbody>

          {tfoot && (
            <tfoot>
              <tr>{tFootCols}</tr>
            </tfoot>
          )}
        </table>

        <div className="customTable-actions">
          <InnerBlocks
            template={[['base/button-sumicity']]}
            allowedBlocks={['base/button-sumicity']}
          />
        </div>
      </div>
    </>
  );
};

export default Edit;
